import React from 'react';
import { X, User, MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface VoiceCallWindowProps {
  conversationId: string;
  clientId: string;
  advisorId: string;
  isClient: boolean;
  onClose: () => void;
  advisorName?: string;
  clientName?: string;
  perMinuteRate?: number;
}

const VoiceCallWindow: React.FC<VoiceCallWindowProps> = ({
  conversationId,
  isClient,
  onClose,
  advisorName,
  clientName,
}) => {
  const navigate = useNavigate();
  const participantName = isClient ? (advisorName || 'Advisor') : (clientName || 'Client');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-6">Voice Call Feature</h2>
          
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6 text-left">
            <div className="flex">
              <div className="flex-shrink-0">
                <User className="h-5 w-5 text-yellow-400" />
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  Voice calling is currently unavailable. Please use text chat to communicate with {participantName}.
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex justify-center space-x-4">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Close
            </button>
            
            <button
              onClick={() => {
                onClose();
                // Navigate back to the conversation
                if (isClient) {
                  navigate('/advisors');
                } else {
                  navigate('/advisor/dashboard');
                }
              }}
              className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              Use Text Chat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceCallWindow;